import styled from "styled-components";

const Divider = styled.hr`
  // width: 90%;
  height: 2px !important;
  background: #B3BAC5;
`;


export default Divider;
